(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-addons"] && !Shopify.designMode) return;
  try {
    class ProductAddons extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.inputs = this.querySelector('.product-addons__inputs');
      this.addEventListener('change', () => this.sync());
      this.sync();
    }

    field(name, value) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      input.setAttribute('form', this.formId);
      return input;
    }

    sync() {
      const fields = [];
      let index = 0;
      const add = (variantId, quantity) => {
        fields.push(this.field(`items[${index}][id]`, variantId));
        fields.push(this.field(`items[${index}][quantity]`, quantity));
        fields.push(this.field(`items[${index}][properties][For]`, this.dataset.for));
        index += 1;
      };

      this.querySelectorAll('.product-addons__check:checked').forEach((check) => {
        const qtySelect = check.dataset.qtyTarget ? document.getElementById(check.dataset.qtyTarget) : null;
        add(check.dataset.variantId, qtySelect ? qtySelect.value : '1');
      });

      const warranty = this.querySelector('.product-addons__group input:checked');
      if (warranty && warranty.value) add(warranty.value, '1');

      const free = this.querySelector('.product-addons__free-select');
      if (free && free.value) fields.push(this.field('properties[Free accessory]', free.value));

      this.inputs.replaceChildren(...fields);

      const hasAddons = index > 0 || Boolean(free && free.value);
      const scope = this.closest('.shopify-section') || document;
      scope.querySelectorAll('.accelerated-checkout-block').forEach((el) => {
        el.hidden = hasAddons;
      });
      const note = this.querySelector('.product-addons__express-note');
      if (note) note.hidden = !hasAddons;
    }
  }

  if (!customElements.get('product-addons')) customElements.define('product-addons', ProductAddons);
  } catch(e) { console.error(e); }
})();

})();
